export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "Annunci",
      current: "Agente IA",
    },
    loading: "Caricamento della configurazione...",
    retry: "Riprova",
    loadError: "Errore durante il caricamento della configurazione.",
    units: "{count} unità | {count} unità",
    faqsLabel: "FAQ",
    unitFallback: "Unità",
    active: "Attivo",
    inactive: "Inattivo",
    botWhatsapp: "Bot WhatsApp",
    otaIa: "IA OTA",
    saving: "Salvataggio...",
    cancel: "Annulla",
    assistant: {
      title: "Assistente WhatsApp",
      desc: "Attiva il bot automatico per rispondere ai tuoi ospiti su WhatsApp.",
    },
    ota: {
      title: "IA OTA",
      desc: "Rispondi automaticamente ai messaggi di Booking.com, Airbnb e altre OTA.",
      warn: "Attiva prima l'Assistente WhatsApp",
    },
    botName: {
      title: "Nome dell'assistente",
      desc: "Il nome che il bot userà per presentarsi ai tuoi ospiti.",
      empty: "Nessun nome assegnato",
      edit: "Modifica",
      placeholder: "Es. Maria, Sofia, Assistente virtuale...",
      save: "Salva",
    },
    faqs: {
      title: "Domande frequenti",
      desc: "Queste FAQ si applicano a <strong>tutte le unità</strong> di questo annuncio. Il bot le userà per rispondere ai tuoi ospiti.",
      add: "Nuova FAQ",
      emptyText: "Non hai ancora impostato domande frequenti.",
      addFirst: "+ Aggiungi la prima FAQ",
      answerEmpty: "Nessuna risposta",
      editTitle: "Modifica",
      deleteTitle: "Elimina",
      questionLabel: "Domanda",
      answerLabel: "Risposta",
      questionPlaceholder: "Scrivi la domanda...",
      answerPlaceholder: "Scrivi la risposta che vedrà l'ospite...",
      saveChanges: "Salva modifiche",
    },
    addModal: {
      title: "Nuova domanda frequente",
      questionLabel: "Domanda",
      questionPlaceholder: "Es. A che ora è il check-in?",
      answerLabel: "Risposta",
      answerPlaceholder: "Es. Il check-in è dalle 15:00. Se arrivi prima, puoi lasciare i bagagli...",
      submit: "Aggiungi FAQ",
    },
    deleteModal: {
      title: "Elimina domanda",
      confirm: "Sei sicuro di voler eliminare questa FAQ?",
      deleting: "Eliminazione...",
      submit: "Sì, elimina",
    },
    types: {
      apartment: "Appartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      room: "Camera",
      studio: "Monolocale",
      default: "Alloggio",
    },
    toast: {
      botOn: "Bot attivato",
      botOff: "Bot disattivato",
      botError: "Errore durante la modifica dello stato del bot",
      otaOn: "IA OTA attivata",
      otaOff: "IA OTA disattivata",
      otaError: "Errore durante la modifica dello stato dell'IA OTA",
      nameUpdated: "Nome dell'assistente aggiornato",
      nameError: "Errore durante il salvataggio del nome",
      faqAdded: "FAQ aggiunta correttamente",
      faqAddError: "Errore durante il salvataggio della FAQ",
      faqUpdated: "FAQ aggiornata",
      faqUpdateError: "Errore durante l'aggiornamento della FAQ",
      faqDeleted: "FAQ eliminata",
      faqDeleteError: "Errore durante l'eliminazione della FAQ",
    },
  },

  listingIndex: {
    title: "Annunci",
    subtitle: "Gestisci la configurazione centrale di ciascuno dei tuoi annunci.",
    countFiltered: "{shown} di {total} annunci",
    count: "{count} annuncio | {count} annunci",
    searchPlaceholder: "Cerca per nome, ID o tipo…",
    clear: "Cancella",
    loadErrorTitle: "Impossibile caricare gli alloggi",
    retry: "Riprova",
    emptyTitle: "Nessun annuncio",
    emptyText: "Non hai ancora annunci registrati.",
    noResultsTitle: 'Nessun risultato per "{query}"',
    noResultsText: "Prova con un altro nome, ID o tipo di annuncio.",
    clearSearch: "Cancella ricerca",
    dragSearchHint: "Cancella la ricerca per riordinare",
    dragHint: "Trascina per riordinare",
    units: "{count} unità | {count} unità",
    botActiveTitle: "Bot GPT attivo",
    channelTitle: "Collegato a Channex",
    icalTitle: "Sincronizzazione iCal",
    editTitle: "Modifica nome",
    modal: {
      title: "Modifica il nome dell'annuncio",
      nameLabel: "Nome dell'annuncio",
      namePlaceholder: "Es. Appartamenti Costa Sol",
      orderLabel: "Ordine dell'annuncio",
      info: "Un <strong>annuncio</strong> raggruppa tutte le strutture che condividono la stessa configurazione, gli stessi messaggi di benvenuto e le stesse politiche. Il nome che imposti qui identificherà il gruppo nel pannello e nei canali di distribuzione collegati.",
      cancel: "Annulla",
      save: "Salva modifiche",
    },
    types: {
      apartment: "Appartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      room: "Camera",
      studio: "Monolocale",
      default: "Alloggio",
    },
    toast: {
      connectionError: "Errore di connessione.",
      reorderSuccess: "Ordine aggiornato correttamente.",
      reorderError: "Impossibile aggiornare l'ordine degli annunci.",
      saveSuccess: "Annuncio aggiornato correttamente.",
      saveError: "Errore durante il salvataggio dell'annuncio.",
    },
  },

  unitDetail: {
    back: "Torna all'annuncio",
    eyebrow: "Unità",
    save: "Salva",
    cancel: "Annulla",
    editNameTitle: "Modifica il nome dell'unità",
    nameFallback: "Unità",
    types: {
      apartment: "Appartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      camping: "Campeggio",
      room: "Camera",
      studio: "Monolocale",
      default: "Alloggio",
    },
    deleteLink: "Elimina unità...",
    dangerNoteBefore: "Rimuove l'unità dall'annuncio",
    dangerNoteAfter: "su WACheckin. Questa azione non può essere annullata.",
    cards: {
      description: { title: "Descrizione", sub: "Dettagli dell'unità" },
      capacity: { title: "Capacità", sub: "Ospiti e posti letto" },
      services: { title: "Dotazioni e comfort", sub: "Cosa offre, con le foto" },
      rules: { title: "Orari", sub: "Orari di check-in e check-out" },
      arrival: { title: "Istruzioni per l'arrivo", sub: "Come arrivare ed entrare · con orario di invio" },
      smartlocks: { title: "Serrature e accessi", sub: "Come entra l'ospite" },
      checkout: { title: "Messaggio di check-out", sub: "Promemoria di check-out · modello" },
      scheduled: { title: "Messaggi programmati", sub: "Messaggi solo per questa unità" },
      unitFaq: { title: "Domande e risposte", sub: "Specifiche di questa unità per l'agente", badge: "IA" },
      welcome: { title: "Messaggio di benvenuto", sub: "Messaggio specifico di questa unità" },
      stockExtra: {
        title: "Stock extra",
        subOff: "Disattivato · raccoglie le prenotazioni di un'altra unità",
        subOn: "Rinforza {name}",
        subOnGeneric: "Rinforza un'altra unità",
        badge: "Attivo",
      },
    },
    sections: {
      aiOnlyLabel: "Domande frequenti dell'unità",
      aiOnlyDesc: "L'agente darà loro priorità quando assiste un ospite che soggiorna in questa unità.",
      specificLabel: "Impostazioni specifiche di questa unità",
      detailLabel: "Descrivi questa unità",
      detailDesc: "Informazioni aggiuntive che usiamo per le prenotazioni dirette e per alimentare l'Agente IA.",
    },
    stockExtra: {
      title: "Stock extra",
      intro: "Su Booking o Airbnb puoi avere un solo annuncio con disponibilità per più appartamenti: siccome se ne può mappare solo uno, il canale manda tutte quelle prenotazioni sulla stessa unità e si accumulano in overbooking.",
      how: "Se segni questa unità come stock extra di un'altra, le prenotazioni che vanno in conflitto con la principale vengono salvate qui e il canale viene avvisato perché anche lì compaiano in questa unità.",
      purpose: "È uno strumento di trasferimento: si attiva per portare qui quello che avevi già venduto sull'OTA e si disattiva quando ogni appartamento ha il proprio annuncio.",
      loading: "Caricamento...",
      activeLabel: "Rinforza {name}",
      activeHint: "Le prenotazioni del canale che vanno in conflitto con {name} vengono salvate in questa unità.",
      activeBadge: "Attivo",
      otherUnit: "un'altra unità",
      warnTitle: "Non attivarlo se ogni appartamento ha già il proprio annuncio mappato sull'OTA:",
      warnText: "lì il canale manda già ogni prenotazione alla sua unità e, con lo stock extra attivo, una prenotazione finirebbe in un appartamento che non è quello che hai venduto.",
      principalOf: "Altre unità si appoggiano già a questa:",
      chooseLabel: "Unità principale",
      chooseDesc: "Scegli l'unità le cui prenotazioni verranno salvate in «{unit}» quando vanno in conflitto tra loro.",
      noCandidates: "Non c'è nessun'altra unità da rinforzare in questo annuncio.",
      activate: "Attiva lo stock extra",
      change: "Cambia l'unità principale",
      saving: "Salvataggio...",
      removeBtn: "Togli lo stock extra",
      removeNote: "Le prenotazioni già salvate qui non si spostano: restano in questa unità.",
      errorCarga: "Non è stato possibile leggere la configurazione dello stock extra. Se hai appena aggiornato, prova a ricaricare la pagina.",
      reintentar: "Riprova",
      toastLoadError: "Non è stato possibile caricare lo stock extra.",
      toastSaveError: "Non è stato possibile salvare lo stock extra.",
    },
    toast: {
      nameEmpty: "Il nome non può essere vuoto",
      nameUpdated: "Nome aggiornato",
      nameError: "Impossibile aggiornare il nome",
    },
  },

  miCuenta: {},
};
